import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { FAQS } from "../mock";

export default function FAQ({ items }) {
  const list = items || FAQS;
  const [open, setOpen] = useState(0);
  return (
    <section className="relative py-28 md:py-36 bg-[#0c0119] border-y border-white/5">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center mb-16">
          <div className="text-xs uppercase tracking-[0.3em] text-acid mb-5 font-label">
           FAQ
          </div>
          <h2 className="font-display text-5xl md:text-6xl leading-[0.95]">
            Common <span className="text-jester">questions.</span>
          </h2>
        </div>

        <div className="space-y-3">
          {list.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className={`border rounded-xl overflow-hidden transition-colors ${
                  isOpen
                    ? "bg-jester-purple/10 border-jester/40"
                    : "bg-white/[0.02] border-white/10 hover:bg-white/[0.04]"
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-6 px-6 py-5 text-left"
                >
                  <span className="font-display text-lg md:text-xl tracking-wide">
                    {f.q}
                  </span>
                  <ChevronDown
                    className={`w-5 h-5 text-acid flex-shrink-0 transition-transform duration-500 ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>
                <div
                  className={`grid transition-all duration-500 ease-out ${
                    isOpen
                      ? "grid-rows-[1fr] opacity-100"
                      : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 pb-6 text-white/75 leading-relaxed">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
